var exports = {
  "kL": "FormSwitch.module__container___UGVFUG",
  "oE": "FormSwitch.module__compact___UGVFUG",
  "_A": "FormSwitch.module__labelContainer___UGVFUG",
  "Pf": "FormSwitch.module__label___UGVFUG",
  "r9": "FormSwitch.module__disabled___UGVFUG",
  "vk": "FormSwitch.module__clickable___UGVFUG",
  "h_": "FormSwitch.module__description___UGVFUG",
  "HV": "FormSwitch.module__switchRoot___UGVFUG",
  "L8": "FormSwitch.module__switchThumb___UGVFUG",
  "nL": "FormSwitch.module__iconChecked___UGVFUG",
  "ao": "FormSwitch.module__iconUnchecked___UGVFUG",
};

module.exports = exports;
